import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';
import { Router } from '@angular/router';
import { UserManagementService } from '../../services/user-management.service';
import { AccountTypeEnum } from '../../common/interfaces/global-interfaces';
import { StorageService } from '../../services/storage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
  standalone: false,
})
export class RegisterComponent {
  form: FormGroup;
  hide = true;
  loading = false;
  private fb: FormBuilder = inject(FormBuilder);
  private authService: AuthService = inject(AuthService);
  private notificationService: NotificationService =
    inject(NotificationService);
  private readonly router: Router = inject(Router);
  private readonly uaaService: UserManagementService = inject(
    UserManagementService
  );
  private readonly storageService = inject(StorageService);
  translate: TranslateService = inject(TranslateService);

  constructor() {}

  ngOnInit() {
    this.form = this.fb.group({
        firstName: [null, Validators.required],
          lastName: [null, Validators.required],
      phoneNumber: [null, [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      email: [null, [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      password: [null, Validators.required],
      confirmPassword: [null, Validators.required],
    });
  }

async register(formValue: any) {
  this.loading = true;

  try {
    if (formValue.password !== formValue.confirmPassword) {
      this.notificationService.errorMessage('Passwords do not match.');
      return;
    }

    const response = await this.authService.register(formValue);

    if (response?.status) {
      this.notificationService.successMessage(response?.message ||'Registration successful!');
      await this.router.navigate(['/auth/message']);
    } else {
      this.notificationService.errorMessage(response?.message || 'Registration failed');
    }
  } catch (e) {
    this.notificationService.errorMessage('An unexpected error occurred.');
  } finally {
    this.loading = false;
  }
}

}
